export default "__VITE_ASSET___Ed1WcNl__"